module.exports = __webpack_public_path__ + "assets/img/img198.80b46e00.png";